'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = exports.storage = exports.authClass = exports.auth = exports.dbClass = exports.db = undefined;

var _app = require('firebase/app');

var _app2 = _interopRequireDefault(_app);

require('firebase/firestore');

require('firebase/auth');

require('firebase/storage');

require('firebase/analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app = null;

var firebaseConfig = {
  apiKey: 'AIzaSyAi7-tl_RGmai5vCQz5QHcOrVXD5ZAZ1ec',
  authDomain: 'anya-8af6f.firebaseapp.com',
  databaseURL: 'https://anya-8af6f.firebaseio.com',
  projectId: 'anya-8af6f',
  storageBucket: 'anya-8af6f.appspot.com',
  messagingSenderId: '256780300',
  appId: '1:256780300:web:569f08216dcdfb5e516629'
};

app = _app2.default.apps.length ? _app2.default.app() : _app2.default.initializeApp(firebaseConfig);

var db = _app2.default.firestore();
var dbClass = _app2.default.firestore;
var auth = _app2.default.auth();
var authClass = _app2.default.auth;
var storage = _app2.default.storage();
var analytics = process.client ? _app2.default.analytics() : '';

exports.db = db;
exports.dbClass = dbClass;
exports.auth = auth;
exports.authClass = authClass;
exports.storage = storage;
exports.analytics = analytics;